import Folder from 'owa-mail-store/lib/store/schema/Folder';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

// Folders that should show total count instead of unread count
const FOLDERS_TO_SHOW_TOTAL_COUNT = ['drafts', 'junkemail', 'outbox', 'notes', 'scheduled'];

export default function shouldDisplayTotalCount(folder: Folder): boolean {
    return (
        FOLDERS_TO_SHOW_TOTAL_COUNT.indexOf(folderIdToName(folder.FolderId.Id)) >= 0 &&
        folder.TotalCount > 0
    );
}
